import React, { useEffect } from 'react';

import styles from './styles.module.css';
import { GIF } from '../../constants';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import Image from '../Image';

interface Props {
  fullScreen?: boolean;
  preventNavigation?: boolean;
}

const Loader: React.FC<Props> = ({ fullScreen = true, preventNavigation = true }) => {
  const { t } = useAppTranslation();
  // Add the beforeunload event listener to warn the user if they try to refresh/close the page
  // Only register when preventNavigation is true (original session-start behavior)
  useEffect(() => {
    if (!preventNavigation) {
      return;
    }
    const beforeUnload = (e: BeforeUnloadEvent) => {
      // mark so the next mount redirects immediately
      e.preventDefault();
      // Chrome (required)
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', beforeUnload);
    return () => window.removeEventListener('beforeunload', beforeUnload);
  }, [preventNavigation]);

  // Disable pull‑to‑refresh only while this screen is mounted (iOS Safari)
  useEffect(() => {
    const htmlEl = document.documentElement;
    const previousValue = htmlEl.style.overscrollBehaviorY; // remember any inline value that might exist
    htmlEl.style.overscrollBehaviorY = 'none';

    return () => {
      // Restore whatever value was there before when the component unmounts
      htmlEl.style.overscrollBehaviorY = previousValue;
    };
  }, []);

  return (
    <div
      className={fullScreen ? styles.containerFullscreen : styles.container}
      role="status"
      aria-busy="true"
      aria-label={t('app.common.loading')}
    >
      <Image src={GIF.waveLoader} />
    </div>
  );
};

export default Loader;
